import React, { SetStateAction } from "react";
import SidePanel from "../sidePanel/SidePanel";
import Button from "../buttons/Button";
import AdvancedSearchForm from "./AdvancedSearchForm";
import { ADVANCED_SEARCH_TRANSLATIONS } from "../../translations/util";

interface IProps {
  setShowAdvancedSearch: React.Dispatch<SetStateAction<boolean>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setAdvancedSearchState: React.Dispatch<SetStateAction<any>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  advancedSearchState: any;
  advancedSearchConfig: Array<{
    name: string;
    tooltipText: string;
    label: string;
    items?: [];
  }>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (data: any) => void;
  onCancel: () => void;
}

const AdvancedSearch = ({
  setShowAdvancedSearch,
  advancedSearchState,
  advancedSearchConfig,
  setAdvancedSearchState,
  onSubmit,
  onCancel,
}: IProps) => {
  return (
    <SidePanel
      toggleFilterPanel={onCancel}
      panelName={ADVANCED_SEARCH_TRANSLATIONS.label}
      className="sidepanel sidepanel-filter fixed z-40 h-full transform transition-transform ease-in duration-150 bg-white"
      showDelete={false}
      onDelete={() => null}
      panelContent={
        <div className="panel-content">
          <form className="search-form">
            <AdvancedSearchForm
              advancedSearchConfig={advancedSearchConfig}
              advancedSearchState={advancedSearchState}
              setAdvancedSearchState={setAdvancedSearchState}
            />
            <div className="flex justify-end form-footer absolute bottom-4 right-3">
              <div className="mr-4">
                <Button
                  className="w-sm"
                  type="button"
                  disabled={false}
                  label={ADVANCED_SEARCH_TRANSLATIONS.cancelButtonLabel}
                  kind="tertiary"
                  onClick={onCancel}
                  dataCy="cancelAdvanceSearch-"
                />
              </div>

              <div className="">
                <Button
                  className="w-sm"
                  type="button"
                  disabled={false}
                  dataCy="applyAdvanceSearch-"
                  label={ADVANCED_SEARCH_TRANSLATIONS.applyButtonLabel}
                  onClick={() => {
                    setShowAdvancedSearch(false);
                    onSubmit(advancedSearchState);
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      }
    />
  );
};

export default AdvancedSearch;
